import { useCallback, useEffect, useState } from "react";

import { fetchWorkspaceSecretStatus } from "../api/workspaceSecretsClient";
import { DEFAULT_WORKSPACE_ID } from "../config/workspace";
import type { OpenAiSecretStatus } from "../types/workspace";

export function useOpenAiSecretStatus(workspaceId: string = DEFAULT_WORKSPACE_ID): {
  status: OpenAiSecretStatus | null;
  isLoading: boolean;
  error: string | null;
  refreshStatus: () => Promise<void>;
  setStatus: (status: OpenAiSecretStatus) => void;
} {
  const [status, setStatus] = useState<OpenAiSecretStatus | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const refreshStatus = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const next = await fetchWorkspaceSecretStatus(workspaceId);
      setStatus(next);
    } catch (refreshError) {
      const message = refreshError instanceof Error ? refreshError.message : "Failed to load secret status";
      setError(message);
    } finally {
      setIsLoading(false);
    }
  }, [workspaceId]);

  useEffect(() => {
    void refreshStatus();
  }, [refreshStatus]);

  return { status, isLoading, error, refreshStatus, setStatus };
}
